document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.promotion-block__video').forEach(function (videoWrapper) {
        var video = videoWrapper.querySelector('video, .video-promotion');
        var playBtn = videoWrapper.closest('.promotion-block').querySelector('button.play-button');
        var pauseBtn = videoWrapper.closest('.promotion-block').querySelector('button.pause-button');

        if (!video || !playBtn || !pauseBtn) return;

        playBtn.style.display = 'none';
        pauseBtn.style.display = '';

        pauseBtn.addEventListener('click', function (e) {
            e.preventDefault();
            video.pause();
            pauseBtn.style.display = 'none';
            playBtn.style.display = '';
        });

        playBtn.addEventListener('click', function (e) {
            e.preventDefault();
            video.play();
            playBtn.style.display = 'none';
            pauseBtn.style.display = '';
        });
    });

    function setPromotionItemHeight() {
        var reference = document.querySelector('.grid__item:not(.item-promotion)');
        if (!reference) return;

        var referenceHeight = reference.offsetHeight;

        document.querySelectorAll('.grid__item.item-promotion').forEach(function (item) {
            item.style.height = referenceHeight + 'px';
        });
    }


    function setGridProductItemsMaxWidth() {
        var gridProductItems = document.querySelectorAll('.grid__item.grid-product');
        if (gridProductItems.length > 0) {
            var width = gridProductItems[0].offsetWidth;
            gridProductItems.forEach(function(item) {
                item.style.maxWidth = width + 'px';
            });
        }
    }

    function resetGridProductItemsMaxWidth() {
        var gridProductItems = document.querySelectorAll('.grid__item.grid-product');
        gridProductItems.forEach(function(item) {
            item.style.maxWidth = '';
        });
    }

    setGridProductItemsMaxWidth();
    setPromotionItemHeight();

    var resizeTimeout;
    window.addEventListener('resize', function() {
        resetGridProductItemsMaxWidth();
        setPromotionItemHeight()
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            setGridProductItemsMaxWidth();
        }, 100); 
    });

});